import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-background" data-id="element-78">
      {/* Background Image with Parallax effect */}
      <motion.div className="absolute inset-0 z-0" initial={{
      scale: 1.05,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 2.5,
      ease: 'easeOut'
    }} data-id="element-79">
        <div className="absolute inset-0 bg-background/70 z-10" data-id="element-80"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-transparent to-background z-10" data-id="element-81"></div>
        <img src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=2070&auto=format&fit=crop" alt="Premium Event" className="w-full h-full object-cover opacity-50 grayscale" data-id="element-82" />
      </motion.div>

      <div className="container relative z-20 mx-auto px-6 md:px-12 flex flex-col items-center text-center mt-20" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.5,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-10 flex items-center gap-6" data-id="element-84">
          <span className="w-16 h-[1px] bg-border" data-id="element-85"></span>
          <span className="text-secondary uppercase tracking-super-wide text-[10px] font-sans font-medium" data-id="element-86">
            Kyiv, Ukraine
          </span>
          <span className="w-16 h-[1px] bg-border" data-id="element-87"></span>
        </motion.div>

        <motion.h1 className="text-6xl md:text-8xl lg:text-9xl font-serif leading-[1.1] text-balance max-w-6xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.5,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-88">
          Мистецтво <br data-id="element-89" />
          <span className="italic text-secondary" data-id="element-90">події</span>
        </motion.h1>

        <motion.p className="mt-12 text-sm md:text-base text-secondary font-sans max-w-xl font-light leading-relaxed uppercase tracking-widest" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.5,
        delay: 0.8
      }} data-id="element-91">
          Ексклюзивна агенція. Бездоганна естетика.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.5,
        delay: 1
      }} className="mt-16" data-id="element-92">
          <a href="#contact" className="group relative inline-flex items-center justify-center px-12 py-5 overflow-hidden border border-border text-primary uppercase tracking-widest text-[11px] transition-all duration-700 hover:border-primary" data-id="element-93">
            <span className="absolute inset-0 w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" data-id="element-94"></span>
            <span className="relative group-hover:text-background transition-colors duration-500" data-id="element-95">
              Обговорити деталі
            </span>
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1.5
    }} data-id="element-96">
        <span className="text-[9px] uppercase tracking-super-wide text-secondary font-sans" data-id="element-97">
          Scroll
        </span>
        <div className="w-[1px] h-16 bg-border relative overflow-hidden" data-id="element-98">
          <motion.div className="absolute top-0 left-0 w-full h-1/2 bg-primary" animate={{
          y: ['-100%', '200%']
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'linear'
        }} data-id="element-99" />
        </div>
      </motion.div>
    </section>;
}